<template>
	<div>
		<el-dialog
			title="新建盘点计划"
			:visible.sync="dialogVisible"
			width="40%"
			top="10vh"
			:close-on-click-modal="false"
			:before-close="handleClose"
			custom-class="plan-dialog">
			<el-form ref="form" :model="form" :rules="rules" label-position="top" size="mini">
				<el-row :gutter="20">
					<div class="title">基础信息</div>
					<el-col :span="12">
						<el-form-item label="计划名称" prop="changeType">
							<el-input v-model="form.assetNo" placeholder="请填写计划名称" size="small" style="width: 100%" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="应用范围" prop="assetNo">
							<el-select
								v-model="form.changeSubType"
								placeholder="请选择应用范围"
								size="small"
								style="width: 100%"></el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="计划有效期" prop="changeDate">
							<el-date-picker
								v-model="form.changeDate"
								value-format="yyyy-MM-dd"
								type="daterange"
								range-separator="至"
								start-placeholder="请选择计划开始日期"
								end-placeholder="请选择计划结束日期"
								style="width: 100%"
								size="small" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="盘点范围" prop="changeSubType1">
							<el-select
								v-model="form.changeSubType"
								placeholder="请选择盘点范围"
								size="small"
								style="width: 100%"></el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="完成时限">
							<el-row>
								<el-col :span="6">
									<div class="select-time">
										<el-select v-model="form.changeSubType" placeholder="请选择" size="small">
											<el-option :label="value" :value="value" v-for="value in 24" :key="value"></el-option>
										</el-select>
										<div class="unit">天</div>
									</div>
								</el-col>
								<el-col :span="6">
									<div class="select-time">
										<el-select v-model="form.changeSubType" placeholder="请选择" size="small">
											<el-option :label="value" :value="value" v-for="value in 24" :key="value"></el-option>
										</el-select>
										<div class="unit">小时</div>
									</div>
								</el-col>
							</el-row>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="盘点资产">
							<el-radio-group v-model="form.radio">
								<el-radio :label="1">
									<span style="margin-right: 5px">全部资产</span>
									<el-tooltip class="item" content="盘点所有资产" placement="top">
										<i class="el-icon-warning-outline"></i>
									</el-tooltip>
								</el-radio>
								<el-radio :label="2">指定资产</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="24" v-if="form.radio == 2">
						<el-form-item label="选择固定资产" prop="changeSubType">
							<el-select v-model="form.changeSubType" placeholder="请选择固定资产" size="small"></el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="计划说明">
							<el-input
								v-model="form.assetNo"
								type="textarea"
								placeholder="请填写计划说明"
								size="small"
								style="width: 100%" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="状态">
							<el-switch v-model="form.status" active-text="启用" inactive-text="关闭"></el-switch>
						</el-form-item>
					</el-col>
					<div class="title">执行环节</div>
					<el-col :span="24">
						<el-form-item label="盘点责任人">
							<el-radio-group v-model="form.radio1">
								<el-radio :label="1">
									<span style="margin-right: 5px">指定岗位</span>
									<el-tooltip class="item" content="选择岗位自动分配" placement="top">
										<i class="el-icon-warning-outline"></i>
									</el-tooltip>
								</el-radio>
								<el-radio :label="2">指定人员</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="选择岗位" v-if="form.radio1 == 1" prop="changeSubType">
							<el-select v-model="form.changeSubType" placeholder="请选择岗位" size="small"></el-select>
						</el-form-item>
						<el-form-item label="选择人员" v-if="form.radio1 == 2" prop="changeSubType">
							<el-select v-model="form.changeSubType" placeholder="请选择人员" size="small"></el-select>
						</el-form-item>
					</el-col>
					<div class="title">生成规则</div>
					<el-col :span="24">
						<el-form-item label="任务提前">
							<el-row>
								<el-col :span="6">
									<div class="select-time">
										<el-select v-model="form.changeSubType" placeholder="请选择" size="small">
											<el-option :label="value" :value="value" v-for="value in 24" :key="value"></el-option>
										</el-select>
										<div class="unit">天</div>
									</div>
								</el-col>
								<el-col :span="7">
									<div class="select-time">
										<el-select v-model="form.changeSubType" placeholder="请选择" size="small">
											<el-option :label="value" :value="value" v-for="value in 24" :key="value"></el-option>
										</el-select>
										<div class="unit">小时</div>
										<div class="unit">推送</div>
									</div>
								</el-col>
							</el-row>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<!-- 按钮 -->
			<span slot="footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="handleSubmit">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'AssetInventoryDialog',
		props: {
			dialogVisible: Boolean,
		},
		data() {
			return {
				form: {
					changeType: '',
					assetId: '',
					assetNo: '',
					radio: 1,
					status: true,
					radio1: 1,
					changeDate: '',
					receiveMethod: '',
					receiveAmount: '',
					changeSubType: '',
					changeBefore: '',
					changeAfter: '',
					disposeMethod: '',
					disposeAmount: '',
					changeDescription: '',
					attachments: '',
				},
				rules: {
					changeType: [{ required: true, message: '请选择', trigger: 'change' }],
					assetNo: [{ required: true, message: '请选择', trigger: 'blur' }],
					changeDate: [{ required: true, message: '请选择', trigger: 'change' }],
					receiveMethod: [{ required: true, message: '请选择', trigger: 'change' }],
					changeSubType: [{ required: true, message: '请选择', trigger: 'change' }],
				},
			};
		},
		watch: {
			dialogVisible(val) {
				if (val) {
					this.$nextTick(() => {
						this.$refs.form && this.$refs.form.resetFields();
					});
				}
			},
		},
		methods: {
			handleClose() {
				this.$emit('update:dialogVisible', false);
			},
			handleSubmit() {
				console.log(this.form);
				this.$refs.form.validate(valid => {
					if (!valid) return;
					this.handleClose();
				});
			},
		},
	};
</script>

<style scoped lang="scss">
	:deep(.plan-dialog) {
		.el-dialog__body {
			max-height: 60vh; // 控制最大高度
			overflow-y: auto; // 开启纵向滚动
		}
		/* 整体滚动条宽度 */
		.el-dialog__body::-webkit-scrollbar {
			width: 6px;
		}

		/* 滚动条轨道 */
		.el-dialog__body::-webkit-scrollbar-track {
			background: #f5f5f5;
			border-radius: 3px;
		}

		/* 滑块 */
		.el-dialog__body::-webkit-scrollbar-thumb {
			background: #c1c1c1;
			border-radius: 3px;
			transition: all 0.3s;
		}

		/* hover 时 */
		.el-dialog__body::-webkit-scrollbar-thumb:hover {
			background: #a8a8a8;
		}

		.title {
			font-size: 16px;
			font-weight: bold;
			margin-bottom: 15px;
		}

		.select-time {
			display: flex;
			gap: 10px;
			align-items: center;
			.unit {
				width: 50px;
			}
		}
	}
</style>
